import React, { useState, useEffect } from "react"
import { FormGroup, Label, Input, Button } from "reactstrap"
import axios from "axios"
const { useNavigate } = require("react-router-dom")
import { toast } from "react-toastify"

const LessonAdditionalInfo = ({
  div_id,
  subject_id,
  date,
  lessonDuration,
  lessonName,
  sid,
  staff_id,
  acad_id,
  result,
}) => {
  const [formData, setFormData] = useState({
    lesson_objective: "",
    learning_outcome: "",
    pedagogical_practices: "",
    audio_visual_adis: "",
    teacher_preparation: "",
    student_preparation: "",
    additional_extended_information: "",
    interdisciplinary_linkage: "",
    infusion_with_life_skills: "",
    art_integration: "",
    story_based: "",
    artificial_intelligence: "",
    fln: "",
    remedial_plan: "",
    cwsn_plan: "",
    assignment: "",
    reference_used: "",
  })
  const navigate = useNavigate()

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  const midFields = [
    ["lesson_objective", "Lesson Objective"],
    ["learning_outcome", "Learning Outcome"],
    ["pedagogical_practices", "Pedagogical Practices"],
    ["audio_visual_adis", "Audio/Visual Aids"],
    ["teacher_preparation", "Teacher Preparation"],
    ["student_preparation", "Student Preparation"],
    ["additional_extended_information", "Additional Extended Information"],
    ["interdisciplinary_linkage", "Interdisciplinary Linkage"],
    ["infusion_with_life_skills", "Infusion with Life Skills"],
  ]

  const supplementalFields = [
    ["art_integration", "Art Integration"],
    ["story_based", "Story Based"],
    ["artificial_intelligence", "Artificial Intelligence"],
    ["fln", "FLN"],
    ["remedial_plan", "Remedial Plan"],
    ["cwsn_plan", "CWSN Plan"],
    ["assignment", "Assignment"],
    ["reference_used", "Reference Used"],
  ]
  const handleSubmit = async () => {
    try {
      const isUpdate = result?.length > 0

      const payload = {
        ...formData,
        fun_name: isUpdate ? "updateLessonplanData" : "addLessonplanData",
        classdiv_id: div_id,
        user_id: staff_id,
        subject_id,
        month: date,
        Lessonduration: lessonDuration,
        Lessonname: lessonName,
        sid,
        acad_id,
        ...(isUpdate && { staff_id: staff_id }),
        ...(isUpdate && { id: result[0].id }),
      }

      const response = await axios.post(
        "https://topschooldev.prisms.in/rest/index.php/staff_list.json",
        payload
      )

      if (response.status === 200) {
        toast.success("submitted successful!")
        navigate("/lesson-report")
      }
    } catch (error) {
      console.error("Submission failed:", error)
    }
  }

  useEffect(() => {
    if (result.length > 0) {
      const [data] = result
      setFormData(prevData => ({
        lesson_objective: data?.lesson_objective || "",
        learning_outcome: data?.learning_outcome || "",
        pedagogical_practices: data?.pedagogical_practices || "",
        audio_visual_adis: data?.audio_visual_adis || "",
        teacher_preparation: data?.teacher_preparation || "",
        student_preparation: data?.student_preparation || "",
        additional_extended_information:
          data?.additional_extended_information || "",
        interdisciplinary_linkage: data?.interdisciplinary_linkage || "",
        infusion_with_life_skills: data?.infusion_with_life_skills || "",
        art_integration: data?.art_integration || "",
        story_based: data?.story_based || "",
        artificial_intelligence: data?.artificial_intelligence || "",
        fln: data?.fln || "",
        remedial_plan: data?.remedial_plan || "",
        cwsn_plan: data?.cwsn_plan || "",
        assignment: data?.assignment || "",
        reference_used: data?.reference_used || "",
      }))
    }
  }, [result])
  return (
    <>
      <div>
        {midFields.map(([field, label]) => (
          <FormGroup key={field}>
            <Label className="text-dark fw-bold" for={field}>
              {label}
            </Label>
            <Input
              type="textarea"
              rows="1"
              id={field}
              name={field}
              value={formData[field]}
              onChange={handleInputChange}
              placeholder={`Enter ${label}`}
            />
          </FormGroup>
        ))}
      </div>

      <div className="form-supplemental">
        <h3 className="text-center fs-5 text-primary font-Poppins fw-bold">
          Supplemental Activities
        </h3>
        {supplementalFields.map(([field, label]) => (
          <FormGroup key={field}>
            <Label className="text-dark fw-bold" for={field}>
              {label}
            </Label>
            <Input
              type="text"
              id={field}
              name={field}
              value={formData[field]}
              onChange={handleInputChange}
              placeholder={`Enter ${label}`}
            />
          </FormGroup>
        ))}
      </div>

      <div className="d-flex justify-content-center mt-4 mb-4">
        <Button color="primary" type="button" onClick={handleSubmit}>
          {result && result.length > 0 ? "Update" : "Submit"}
        </Button>
      </div>
    </>
  )
}

export default LessonAdditionalInfo
